import { JumpSportItem } from './jump-sport-list';

export const jumpSportListO61: JumpSportItem[] = [
  {
    sportTypeId: -1,
    label: '无',
    children: [
      {
        sportId: -1,
        label: '无',
        translationKey: undefined
      }
    ]
  },
  {
    sportTypeId: 0,
    label: '水上运动',
    children: [
      {
        sportId: 9,
        label: '泳池游泳',
        translationKey: 'swim_indoor.sport'
      },
      {
        sportId: 10,
        label: '开放水域游泳',
        translationKey: 'swim_outdoor.sport'
      },
      {
        sportId: 100,
        label: '帆船',
        translationKey: 'sailboat.sport'
      },
      {
        sportId: 101,
        label: '桨板',
        translationKey: 'paddle_board.sport'
      },
      {
        sportId: 102,
        label: '水球',
        translationKey: 'water_polo.sport'
      },
      {
        sportId: 103,
        label: '水上运动',
        translationKey: 'water_sports.sport'
      },
      {
        sportId: 104,
        label: '滑水',
        translationKey: 'surfing.sport'
      },
      {
        sportId: 105,
        label: '皮划艇',
        translationKey: 'canoeing.sport'
      },
      {
        sportId: 106,
        label: '皮艇漂流',
        translationKey: 'kayak_rafting.sport'
      },
      {
        sportId: 107,
        label: '划船',
        translationKey: 'rowing.sport'
      },
      {
        sportId: 108,
        label: '摩托艇',
        translationKey: 'motorboat.sport'
      },
      {
        sportId: 109,
        label: '蹼泳',
        translationKey: 'web_swimming.sport'
      },
      {
        sportId: 110,
        label: '跳水',
        translationKey: 'driving.sport'
      },
      {
        sportId: 111,
        label: '花样游泳',
        translationKey: 'fancy_swimming.sport'
      },
      {
        sportId: 113,
        label: '风筝冲浪',
        translationKey: 'kite_surfing.sport'
      },
      {
        sportId: 114,
        label: '室内冲浪',
        translationKey: 'indoor_surfing.sport'
      },
      {
        sportId: 115,
        label: '龙舟',
        translationKey: 'dragon_boat.sport'
      }
    ]
  },
  {
    sportTypeId: 1,
    label: '户外运动',
    children: [
      {
        sportId: 1,
        label: '户外跑步',
        translationKey: 'outdoor_sports.sport'
      },
      {
        sportId: 2,
        label: '健走',
        translationKey: 'walk_outdoor.sport'
      },
      {
        sportId: 15,
        label: '徒步',
        translationKey: 'hiking_outdoor.sport'
      },
      {
        sportId: 6,
        label: '户外骑行',
        translationKey: 'ride_outdoor.sport'
      },
      {
        sportId: 4,
        label: '登山',
        translationKey: 'climbing.sport'
      },
      {
        sportId: 5,
        label: '越野',
        translationKey: 'cross_country.sport'
      },
      {
        sportId: 17,
        label: '铁人三项',
        translationKey: 'triathlon.sport'
      },
      {
        sportId: 201,
        label: '滑板',
        translationKey: 'skate.sport'
      },
      {
        sportId: 202,
        label: '轮滑',
        translationKey: 'roller_skating.sport'
      },
      {
        sportId: 203,
        label: '跑酷',
        translationKey: 'parkour.sport'
      },
      {
        sportId: 204,
        label: '沙滩车',
        translationKey: 'atv.sport'
      },
      {
        sportId: 205,
        label: '滑翔伞',
        translationKey: 'paraglider.sport'
      },
      {
        sportId: 206,
        label: '小轮车',
        translationKey: 'bicycle_moto.sport'
      },
      {
        sportId: 207,
        label: '竞走',
        translationKey: 'hell_and_toe.sport'
      },
      {
        sportId: 208,
        label: '操场跑步',
        translationKey: 'track_running.sport'
      }
    ]
  },
  {
    sportTypeId: 2,
    label: '训练',
    children: [
      // 之前是自由训练
      {
        sportId: 8,
        label: '自由活动',
        translationKey: 'free_training.sport'
      },
      {
        sportId: 3,
        label: '室内跑步',
        translationKey: 'run_indoor.sport'
      },
      {
        sportId: 14,
        label: '跳绳',
        translationKey: 'rope_skipping.sport'
      },
      {
        sportId: 16,
        label: '高强度间歇训练',
        translationKey: 'high_interval_training.sport'
      },
      {
        sportId: 12,
        label: '瑜伽',
        translationKey: 'yoga.sport'
      },
      {
        sportId: 7,
        label: '室内单车',
        translationKey: 'ride_indoor.sport'
      },
      {
        sportId: 11,
        label: '椭圆机',
        translationKey: 'elliptical_machine.sport'
      },
      {
        sportId: 13,
        label: '划船机',
        translationKey: 'rowing_machine.sport'
      },
      {
        sportId: 300,
        label: '爬楼机',
        translationKey: 'climbing_machine.sport'
      },
      {
        sportId: 302,
        label: '踏步机',
        translationKey: 'stepper.sport'
      },
      {
        sportId: 308,
        label: '力量训练',
        translationKey: 'strength_training.sport'
      },
      {
        sportId: 324,
        label: '动感单车',
        translationKey: 'spinning.sport'
      },
      // 室内健身
      {
        sportId: 399,
        label: '健身房训练',
        translationKey: 'indoor_gym.sport'
      },
      {
        sportId: 304,
        label: '柔韧训练',
        translationKey: 'flexibility_training.sport'
      },
      {
        sportId: 305,
        label: '普拉提',
        translationKey: 'pilates.sport'
      },
      {
        sportId: 306,
        label: '体操',
        translationKey: 'gymnastics.sport'
      },
      {
        sportId: 307,
        label: '拉伸',
        translationKey: 'stretch.sport'
      },
      {
        sportId: 309,
        label: '交叉训练',
        translationKey: 'crossfit.sport'
      },
      {
        sportId: 301,
        label: '爬楼梯',
        translationKey: 'climb_stairs.sport'
      },
      {
        sportId: 310,
        label: '健身操',
        translationKey: 'aerobics.sport'
      },
      {
        sportId: 312,
        label: '墙球',
        translationKey: 'wall_ball.sport'
      },
      {
        sportId: 315,
        label: '举重',
        translationKey: 'weightlifting.sport'
      },
      {
        sportId: 316,
        label: '硬拉',
        translationKey: 'deadlift.sport'
      },
      {
        sportId: 317,
        label: '波比跳',
        translationKey: 'bobby_jump.sport'
      },
      {
        sportId: 318,
        label: '仰卧起坐',
        translationKey: 'sit_ups.sport'
      },
      {
        sportId: 319,
        label: '功能性训练',
        translationKey: 'functional_training.sport'
      },
      {
        sportId: 322,
        label: '腰腹训练',
        translationKey: 'waist_training.sport'
      },
      {
        sportId: 323,
        label: '背部训练',
        translationKey: 'back_training.sport'
      },
      {
        sportId: 325,
        label: '漫步机',
        translationKey: 'walking_machine.sport'
      },
      {
        sportId: 327,
        label: '单杠',
        translationKey: 'single_bar.sport'
      },
      {
        sportId: 328,
        label: '双杠',
        translationKey: 'parallel_bars.sport'
      },
      {
        sportId: 326,
        label: '踏步训练',
        translationKey: 'step_training.sport'
      },
      {
        sportId: 329,
        label: '团体操',
        translationKey: 'group_callisthenics.sport'
      },
      {
        sportId: 330,
        label: '搏击操',
        translationKey: 'strike.sport'
      },
      {
        sportId: 331,
        label: '战绳',
        translationKey: 'battle_rope.sport'
      },
      {
        sportId: 332,
        label: '混合有氧',
        translationKey: 'mixed_aerobic.sport'
      },
      {
        sportId: 333,
        label: '室内步行',
        translationKey: 'walk_indoor.sport'
      }
    ]
  },
  {
    sportTypeId: 4,
    label: '舞蹈类运动',
    children: [
      {
        sportId: 400,
        label: '广场舞',
        translationKey: 'square_dance.sport'
      },
      {
        sportId: 401,
        label: '肚皮舞',
        translationKey: 'belly_dance.sport'
      },
      {
        sportId: 402,
        label: '芭蕾舞',
        translationKey: 'ballet.sport'
      },
      {
        sportId: 403,
        label: '街舞',
        translationKey: 'street_dance.sport'
      },
      {
        sportId: 404,
        label: '尊巴',
        translationKey: 'zumba.sport'
      },
      {
        sportId: 405,
        label: '民族舞',
        translationKey: 'national_dance.sport'
      },
      {
        sportId: 406,
        label: '爵士舞',
        translationKey: 'jazz.sport'
      },
      {
        sportId: 407,
        label: '拉丁舞',
        translationKey: 'latin_dance.sport'
      },
      {
        sportId: 408,
        label: '嘻哈舞',
        translationKey: 'hip_hop_dance.sport'
      },
      {
        sportId: 409,
        label: '钢管舞',
        translationKey: 'pole_dance.sport'
      },
      {
        sportId: 410,
        label: '霹雳舞',
        translationKey: 'breakdancing.sport'
      },
      {
        sportId: 411,
        label: '交际舞',
        translationKey: 'social_dancing.sport'
      },
      {
        sportId: 412,
        label: '现代舞',
        translationKey: 'modern_dancing.sport'
      },
      {
        sportId: 499,
        label: '舞蹈',
        translationKey: 'dance.sport'
      }
    ]
  },
  {
    sportTypeId: 5,
    label: '搏击类运动',
    children: [
      {
        sportId: 500,
        label: '拳击',
        translationKey: 'boxing.sport'
      },
      {
        sportId: 501,
        label: '摔跤',
        translationKey: 'wrestling.sport'
      },
      {
        sportId: 502,
        label: '武术',
        translationKey: 'martial_arts.sport'
      },
      {
        sportId: 503,
        label: '太极',
        translationKey: 'taichi.sport'
      },
      {
        sportId: 504,
        label: '泰拳',
        translationKey: 'muay_thai.sport'
      },
      {
        sportId: 505,
        label: '柔道',
        translationKey: 'judo.sport'
      },
      {
        sportId: 506,
        label: '跆拳道',
        translationKey: 'taekwondo.sport'
      },
      {
        sportId: 507,
        label: '空手道',
        translationKey: 'karate.sport'
      },
      {
        sportId: 508,
        label: '自由搏击',
        translationKey: 'free_sparring.sport'
      },
      {
        sportId: 509,
        label: '剑术/剑道',
        translationKey: 'swordsmanship.sport'
      },
      {
        sportId: 510,
        label: '击剑',
        translationKey: 'fencing.sport'
      },
      {
        sportId: 511,
        label: '柔术',
        translationKey: 'jujitsu.sport'
      }
    ]
  },
  {
    sportTypeId: 6,
    label: '球类运动',
    children: [
      {
        sportId: 600,
        label: '足球',
        translationKey: 'football.sport'
      },
      {
        sportId: 601,
        label: '篮球',
        translationKey: 'basketball.sport'
      },
      {
        sportId: 619,
        label: '高尔夫',
        translationKey: 'golf.sport'
      },
      {
        sportId: 602,
        label: '排球',
        translationKey: 'volleyball.sport'
      },
      {
        sportId: 603,
        label: '棒球',
        translationKey: 'baseball.sport'
      },
      {
        sportId: 604,
        label: '垒球',
        translationKey: 'softball.sport'
      },
      {
        sportId: 605,
        label: '橄榄球',
        translationKey: 'rugby.sport'
      },
      {
        sportId: 606,
        label: '曲棍球',
        translationKey: 'hockey.sport'
      },
      {
        sportId: 607,
        label: '乒乓球',
        translationKey: 'pingpong.sport'
      },
      {
        sportId: 608,
        label: '羽毛球',
        translationKey: 'badminton.sport'
      },
      {
        sportId: 609,
        label: '网球',
        translationKey: 'tennis.sport'
      },
      {
        sportId: 610,
        label: '板球',
        translationKey: 'cricket.sport'
      },
      {
        sportId: 611,
        label: '手球',
        translationKey: 'handball.sport'
      },
      {
        sportId: 612,
        label: '保龄球',
        translationKey: 'bowling.sport'
      },
      {
        sportId: 613,
        label: '壁球',
        translationKey: 'squash.sport'
      },
      {
        sportId: 614,
        label: '台球',
        translationKey: 'billiards.sport'
      },
      {
        sportId: 615,
        label: '毽球',
        translationKey: 'shuttlecock.sport'
      },
      {
        sportId: 616,
        label: '沙滩足球',
        translationKey: 'beach_football.sport'
      },
      {
        sportId: 617,
        label: '沙滩排球',
        translationKey: 'beach_volleyball.sport'
      },
      {
        sportId: 618,
        label: '藤球',
        translationKey: 'sepak_takraw.sport'
      },
      {
        sportId: 621,
        label: '室内足球',
        translationKey: 'indoor_football.sport'
      },
      {
        sportId: 622,
        label: '沙包球',
        translationKey: 'sandbags_ball.sport'
      },
      {
        sportId: 623,
        label: '地掷球',
        translationKey: 'bocci.sport'
      },
      {
        sportId: 624,
        label: '回力球',
        translationKey: 'hihi_ball.sport'
      },
      {
        sportId: 625,
        label: '门球',
        translationKey: 'gateball.sport'
      },
      {
        sportId: 626,
        label: '躲避球',
        translationKey: 'dodgeball.sport'
      }
    ]
  },
  {
    sportTypeId: 7,
    label: '冰雪运动',
    children: [
      {
        sportId: 700,
        label: '户外滑冰',
        translationKey: 'outdoor_skating.sport'
      },
      {
        sportId: 701,
        label: '冰壶',
        translationKey: 'curling.sport'
      },
      {
        sportId: 702,
        label: '雪上运动',
        translationKey: 'snow_sports.sport'
      },
      {
        sportId: 703,
        label: '雪地摩托',
        translationKey: 'snowmobile.sport'
      },
      {
        sportId: 704,
        label: '冰球',
        translationKey: 'puck.sport'
      },
      {
        sportId: 705,
        label: '雪车',
        translationKey: 'snow_car.sport'
      },
      {
        sportId: 706,
        label: '雪橇',
        translationKey: 'sled.sport'
      },
      {
        sportId: 707,
        label: '室内滑冰',
        translationKey: 'indoor_skating.sport'
      },
      {
        sportId: 708,
        label: '单板滑雪',
        translationKey: 'snowboarding.sport'
      },
      {
        sportId: 709,
        label: '双板滑雪',
        translationKey: 'double_board_skiing.sport'
      },
      {
        sportId: 710,
        label: '越野滑雪',
        translationKey: 'cross_country_skiing.sport'
      }
    ]
  },
  {
    sportTypeId: 8,
    label: '休闲运动',
    children: [
      {
        sportId: 800,
        label: '射箭',
        translationKey: 'archery.sport'
      },
      {
        sportId: 801,
        label: '飞镖',
        translationKey: 'darts.sport'
      },
      {
        sportId: 802,
        label: '骑马',
        translationKey: 'horse_riding.sport'
      },
      {
        sportId: 803,
        label: '拔河',
        translationKey: 'tug_of_war.sport'
      },
      {
        sportId: 804,
        label: '呼啦圈',
        translationKey: 'hula_hoop.sport'
      },
      {
        sportId: 805,
        label: '放风筝',
        translationKey: 'fly_kite.sport'
      },
      {
        sportId: 806,
        label: '钓鱼',
        translationKey: 'fishing.sport'
      },
      {
        sportId: 807,
        label: '飞盘',
        translationKey: 'frisbee.sport'
      },
      {
        sportId: 808,
        label: '踢毽子',
        translationKey: 'shuttlecock_kicking.sport'
      },
      {
        sportId: 809,
        label: '秋千',
        translationKey: 'swing.sport'
      },
      {
        sportId: 810,
        label: '体感游戏',
        translationKey: 'motion_sensing_game.sport'
      },
      {
        sportId: 620,
        label: '桌上足球',
        translationKey: 'foosball.sport'
      },
      {
        sportId: 627,
        label: '沙狐球',
        translationKey: 'shuffleboard.sport'
      },
      {
        sportId: 811,
        label: '电子竞技',
        translationKey: 'electronic_sports.sport'
      }
    ]
  },
  {
    sportTypeId: 9,
    label: '棋牌运动',
    children: [
      {
        sportId: 900,
        label: '国际象棋',
        translationKey: 'chess.sport'
      },
      {
        sportId: 901,
        label: '国际跳棋',
        translationKey: 'draughts.sport'
      },
      {
        sportId: 902,
        label: '围棋',
        translationKey: 'weiqi.sport'
      },
      {
        sportId: 903,
        label: '桥牌',
        translationKey: 'bridge.sport'
      },
      {
        sportId: 904,
        label: '桌游',
        translationKey: 'board_games.sport'
      }
    ]
  },
  {
    sportTypeId: 100,
    label: '其他运动',
    children: [
      {
        sportId: 10000,
        label: '马术',
        translationKey: 'equesttrian.sport'
      },
      {
        sportId: 10001,
        label: '田径',
        translationKey: 'track_and_field.sport'
      },
      {
        sportId: 10002,
        label: '赛车',
        translationKey: 'racing_car.sport'
      }
    ]
  }
];
